module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"keywords":"Keywords","keywordsPlaceholder":"Add keywords.."},"fr":{"keywords":"Mots-clés","keywordsPlaceholder":"Ajouter des mots-clés.."},"de":{"keywords":"Schlüsselwörter","keywordsPlaceholder":"Schlüsselwörter hinzufügen.."}}')
  delete Component.options._Ctor
}
